export var Env;
(function (Env) {
    Env[Env["Stage"] = 0] = "Stage";
    Env[Env["Production"] = 1] = "Production";
})(Env || (Env = {}));
